import Color from 'color';
import styled from 'styled-components';

export const Button = styled.button<{ themeColor: string }>`
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: ${(props) => props.themeColor};
  color: ${(props) =>
    Color(props.themeColor).isDark()
      ? '#ffffff'
      : Color(props.themeColor).darken(0.8).hex()};
  border-radius: 3px;
  cursor: pointer;
  font-size: 20px;

  &:hover {
    background: ${(props) => Color(props.themeColor).darken(0.2).hex()};
  }
`;
